/* eslint-disable @angular-eslint/directive-selector */
/* eslint-disable @typescript-eslint/no-explicit-any */

import {
  AfterViewInit,
  Directive,
  ElementRef,
  HostListener,
  Renderer2,
} from '@angular/core';
@Directive({ selector: '[ellipsisTooltip]' })
export class EllipsisTooltipDirective implements AfterViewInit {
  domElement: any;

  constructor(
    private readonly elementRef: ElementRef,
    private readonly renderer: Renderer2,
  ) {
    this.domElement = this.elementRef.nativeElement;
  }

  ngAfterViewInit(): void {
    this.renderer.setProperty(this.domElement, 'scrollTop', 1);
    this.setToolTip();
  }

  @HostListener('window:resize')
  setToolTip() {
    if (this.domElement?.parentElement) {
      if (
        this.domElement.offsetWidth >
        this.domElement.parentElement.offsetWidth -
          this.domElement.offsetLeft * 2
      ) {
        this.renderer.setAttribute(
          this.domElement,
          'title',
          this.domElement.textContent,
        );
      } else {
        this.renderer.removeAttribute(this.domElement, 'title');
      }
    }
  }
}
